<template>
  <div :class="['appbanner', show ? 'show': '']" ref="appbanner">
    <button class="close" @click="close"><v-icon color="white" >{{icons.mdiClose}}</v-icon></button>
    <div class="info-block">
      <v-avatar>
        <img class="logo" alt="logo" :src="client.logo">
      </v-avatar>
      <div class="content">
        <h3>{{client.name}}</h3>
      </div>
    </div>
    <div class="app-buttons">
      <a :href="playStoreUrl" @click="close" target="_blank">
        <img class="google-play-badge" alt="Google Play" :src="badges.android">
      </a>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import _ from 'lodash';
  import {mdiClose} from '@mdi/js';
  import {storage} from '@/store';
  import {android} from './badges/android.js'

  export default {
    name: "AppPromotionBanner",
    data: () => ({
      platform: '',
      show: false,
      showAndroidButton: false,
      showIOSButton: false,
      rating: 4.5,
      icons: {mdiClose},
      promotionStorage: JSON.parse(storage.getItem('promotion')),
      badges: {android}
    }),
    mounted() {
      if (this.device && !_.get(this.promotionStorage, 'ignoreAppBanner', false) && this.isAndroid && this.playStoreUrl) {
        setTimeout(() => {
          this.slideIn();
        }, 1000);
      }
    },
    computed: {
      ...mapGetters(['client', 'device']),
      playStoreUrl() {
        return _.get(this.client, 'playstore_url');
      },
      appStoreUrl() {
        return _.get(this.client, 'appstore_url');
      },
      isAndroid() {
        return _.get(this.device, 'os.name').toLowerCase() === 'android';
      }
    },
    methods: {
      close() {
        this.promotionStorage = JSON.parse(storage.getItem('promotion'));
        storage.setItem('promotion', JSON.stringify({ignoreAppBanner: true, ...this.promotionStorage}));
        this.slideOut();
      },
      slideIn() {
        let bannerHeight = this.$refs.appbanner.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--appbanner-height', bannerHeight + 'px');
        document.body.classList.add('appbanner-active');
        this.show = true;
      },
      slideOut() {
        this.show = false;
        document.documentElement.style.setProperty('--appbanner-height', '0px');
        this.$refs.appbanner.addEventListener('transitionend', () => {
          document.body.classList.remove('appbanner-active');
        }, {once: true})
      },
    }
  }
</script>

<style scoped lang="scss">
  .appbanner {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 300;
    background-color: #FFF;
    background: #3d3d3d url('data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7');
    box-shadow: inset 0 2px 0 var(--v-primary-base);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .5em 1em;
    transform: translateY(-100%);
    transition:  transform .4s ease-out;
    color: #fff;
    &.show {
      transform: translateY(0);
    }
    p {
      margin: 0;
      line-height: 1em;
    }
    ::v-deep .v-rating .v-icon {
      padding: 0.1em;
      &:first-child {
        padding-left: 0;
      }
    }
    .info-block {
      display: flex;
      align-items: center;
      .content {
        margin-left: 1em;
      }
    }
    .v-avatar img {
      border: 2px solid #fff;
    }
    .close {
      right: 0;
      top: 0;
      position: absolute;
      font-size: 0;
      padding: 4px 2px 14px 12px;
      cursor: default;
      .v-icon.v-icon {
        height: 18px;
        width: 18px;
        cursor: pointer;
      }
    }
    .app-buttons {
      display: flex;
      a {
        margin: 0 .4em;
      }
    }
  }
  a {
    display: block;
    line-height: 0;
    position: relative;
    right: 10px;
    .google-play-badge {
      height: 36px;
    }
  }
</style>
